export default {
	path: '/',
	redirect: '/dashboard',
	children: [
		{
			path: '/dashboard',
			name: 'DashboardPage',
			component: () => import('../pages/index.vue')
		}
	]
}
